export const TAB_IDS = ['main', 'experience', 'education', 'certificates', 'aboutApp'];

/** Локальный PDF из public/resume.pdf */
export const RESUME_PDF_URL = `${process.env.PUBLIC_URL}/resume.pdf`;

export const RESUME_PDF_FILENAME = {
  ru: 'Slatimov_Andrey_Resume.pdf',
  en: 'Slatimov_Andrey_CV.pdf',
};
